module.exports = __webpack_public_path__ + "img/pizza-2.4965094d.jpg";